<ng-container *transloco="let convert;">
  @if (header$ | async; as header) {
    <header class="sell-details-header d-flex flex-column">
      <div class="d-flex mb-1 flex-column flex-md-row align-items-baseline">
        <h2 class="m-0 mb-1">
          <span role="alert">
            {{ header.title }}
          </span>
          <br class="d-md-none" />
          <small class="ms-0 ms-md-2 me-4 fw-normal">
            {{ header.description }}
          </small>
        </h2>
        <p class="d-md-none mb-1 mb-md-0 me-auto">
          <span class="sell-details-header__vin">{{ header.vin }}</span>
          <span class="sell-details-header__vin-copy"><button ngxClipboard class="vin-copy"
          (cbOnSuccess)="copied()" [cbContent]="header.vin">{{convert('sellModule.details.detailsHeader.copyVin')}}</button></span>
        </p>
        <p class="d-md-none mb-1 mb-md-0 me-auto">
          <span class="sell-details-header__stock-number-mobile">
            <small><strong> {{convert('sellModule.details.detailsHeader.stockUnit')}} {{header.stockNumber}} </strong> </small>
          </span>
        </p>
        <div class="d-flex align-items-baseline sell-details-header__disclosures">
          @if (header.hasRedLight || header.hasYellowLight) {
            <div class="me-2 me-md-3 pt-1 yellow-lights-disclosures">
              @if (header.hasRedLight) {
                <app-condition-indicator variant="red"
                [conditionIndicatorTranslations]="conditionIndicatorTranslations"></app-condition-indicator>
              }
              @if (header.hasYellowLight) {
                <app-vehicle-disclosures-indicator variant="yellow"
                  [vehicleDisclosuresIndicatorTranslations]="conditionIndicatorTranslations"
                  [bulletedToolTipContentToolTipOverCount]=true [hideDisclosureCount]=true
                  [vehicleDisclosuresList]="header.yellowLightLabel">
                </app-vehicle-disclosures-indicator>
              }
            </div>
          }
          @if (header.odometer && header.odometer !== 0) {
            <app-datalist-item
              identifier="vehicle_details_odometer_text"
              label="{{convert('sellModule.details.detailsHeader.odometer')}}"
              value="{{ header.odometer | number }} {{detailsHeaderTranslations.distanceUnit}}"
              >
            </app-datalist-item>
          }
          <span class="d-md-none mobile-email-icon-section d-flex align-items-center p-1">
            @if (showEmailIcon) {
              <a [attr.aria-label]="convert('sellModule.details.detailsHeader.ariaLabelEmailVdp')"
                tabindex="0"
                (click)="goToEmail(header.inventoryItemUuid)"
                >
                <img [src]="emailImageIconSrc" alt="{{convert('sellModule.details.detailsHeader.altenvelope')}}">
              </a>
            }
            <button
              class="card__print card__icon-button btn-link icon-button d-flex print-icon-btn"
              data-track-name="button"
              data-track-trigger="print"
              data-track-elem="icon"
              type="button"
              [attr.data-track-name]="'Print Vehicle-' + title"
              [attr.aria-label]="convert('sellModule.details.detailsHeader.ariaLabelPrint') + title"
              (click)="printVDP()"
              >
              <img src="../../../../ui/assets/icons/print.svg" class="print-icon">
            </button>
            <button
              printSectionId="{{header.inventoryItemUuid}}"
              ngxPrint
              useExistingCss="true"
              class="d-none"
            ></button>
          </span>
        </div>
      </div>
      <div class="d-none d-md-flex">
        <p class="mb-1 mb-md-0 me-auto">
          <span class="sell-details-header__vin">{{ header.vin }}</span>
          <span class="sell-details-header__vin-copy"><button ngxClipboard class="vin-copy" #copyVinButton
          (cbOnSuccess)="copied()" [cbContent]="header.vin">{{convert('sellModule.details.detailsHeader.copyVin')}}</button></span>
          <span>
            <span class="sell-details-header__stock-label">{{convert('sellModule.details.detailsHeader.stockUnit')}}</span>
            <span class="sell-details-header__stock-value"> {{header.stockNumber}}</span>
          </span>
        </p>
        <div class="align-self-end pt-1 email-icon-section d-flex align-items-center pb-1">
          @if (showEmailIcon) {
            <a [attr.aria-label]="convert('sellModule.details.detailsHeader.ariaLabelEmailVdp')"
              tabindex="0"
              (click)="goToEmail(header.inventoryItemUuid)"
              (keydown.enter)="goToEmail(header.inventoryItemUuid)"
              >
              <img [src]="emailImageIconSrc" alt="{{convert('sellModule.details.detailsHeader.altenvelope')}}">
            </a>
          }
          <button
            class="card__print card__icon-button btn-link icon-button ms-md-2 ms-lg-4 p-0 border-0 print-icon-btn"
            data-track-name="button"
            data-track-trigger="print"
            data-track-elem="icon"
            type="button"
            [attr.data-track-name]="'Print Vehicle-' + title"
            [attr.aria-label]="convert('sellModule.details.detailsHeader.ariaLabelPrint') + title"
            (click)="printVDP()"
            >
            <img src="../../../../ui/assets/icons/print.svg" class="print-icon">
          </button>
          <button
            printSectionId="{{header.inventoryItemUuid}}"
            ngxPrint
            useExistingCss="true"
            class="d-none"
          ></button>
        </div>
      </div>
      @if (showPrintContent) {
        <div class="print-content">
          <ng-content *ngTemplateOutlet="printContent"></ng-content>
        </div>
      }
      <ng-template #printContent>
        <div class="wrapper" id="{{header.inventoryItemUuid}}">
          <app-print-vdp-sell
            [images]="images$ | async"
            [vehicleInfo]="vehicleInfo"
            [auctionItem]="auctionItem"
            [tabFocus]="bookValue"
            [blackBookValues]="blackBookValues"
            [nadaValues]="nadaValues"
          ></app-print-vdp-sell>
        </div>
      </ng-template>
    </header>
  }
</ng-container>
